
import React from "react";
import { Button } from "@/components/ui/button";
import { Dices, HelpCircle } from "lucide-react";
import { motion } from "framer-motion";
import HowItWorksDialog from "../HowItWorksDialog";
import { useSettings } from "@/context/SettingsContext";
import { cn } from "@/lib/utils";

interface WelcomeProps {
  startRolling: () => void;
}

const Welcome: React.FC<WelcomeProps> = ({ startRolling }) => {
  const { darkMode } = useSettings();
  
  return (
    <motion.div 
      key="grounding"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="w-full my-4"
    >
      <div className={cn(
        "border-l-4 border-[#1E0C46] p-4 rounded-lg shadow-sm w-full",
        darkMode ? "bg-[#2d1a45]/90" : "bg-white"
      )}>
        <motion.p 
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
          className={cn(
            "text-lg font-normal leading-relaxed",
            darkMode ? "text-[#FBF3F1]" : "text-gray-700"
          )}
        >
          "Your only aim is to check in with where you are right now—and what you're already responding to."
        </motion.p>
      </div>
      
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.0, duration: 0.5 }}
        className="flex flex-col items-center mt-6 gap-4"
      >
        <Button 
          onClick={startRolling} 
          size="lg"
          className={cn(
            "px-10 py-6 text-lg rounded-full shadow-sm flex items-center gap-2 transition-all duration-300 hover:shadow-md",
            darkMode 
              ? "bg-[#6127A0] hover:bg-[#4d1f80] text-white"
              : "bg-[#6127A0] hover:bg-[#4d1f80] text-white"
          )}
        >
          <Dices className="mr-2" />
          Roll for Inspiration
        </Button>
        
        <div className="mt-2">
          <HowItWorksDialog 
            trigger={
              <Button 
                variant="link" 
                size="sm"
                className={cn(
                  "flex items-center gap-1.5",
                  darkMode 
                    ? "text-[#AE78F0] hover:text-[#c096ff]"
                    : "text-[#6127A0] hover:text-[#4d1f80]"
                )}
              >
                <HelpCircle className="h-4 w-4" />
                <span>How does this work?</span>
              </Button>
            }
          />
        </div>
      </motion.div>
    </motion.div>
  );
};

export default Welcome;
